// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.reviews-tab-content {
  padding: 10px 25px;
  max-height: calc(100vh - 200px);
  text-align: justify;
}

.header-style {
  margin: 10px;
  font-size: 18px;
}

/* TODO(mdc-migration): The following rule targets internal classes of card that may no longer apply for the MDC version. */
mat-card.card-style {
  padding: 50px;
}

.tgpp-print-icon {
  cursor: pointer;
  float: right;
}

.tgpp-print-title {
  display: none;
}

.tgpp-title {
  display: none;
}

.card-style {
  margin: 20px 30px;
}

.reviewguide-container .modal {
  display: block; /* Hidden by default */
  position: fixed; /* Stay in place */
  z-index: 1; /* Sit on top */
  left: 0;
  top: 0;
  width: 100%; /* Full width */
  height: 100%; /* Full height */
  overflow: auto; /* Enable scroll if needed */
  background-color: rgb(0, 0, 0); /* Fallback color */
  background-color: rgba(0, 0, 0, 0.4); /* Black w/ opacity */
  margin-top: 40px;
}

.reviewguide-container input {
  height: auto;
  margin-top: 30px;
}

.reviewguide-container .update-disclaimer-button {
  padding: 10px 10px 10px;
}

.disclaimer-save-div {
  margin-top: 25px;
}

.reviewguide-container .mat-datepicker-input {
  width: 92%;
}

/* Modal Content/Box */
.modal-content {
  background-color: transparent;
  margin: 10% auto; /* 15% from the top and centered */
  padding: 20px;
  width: 80%; /* Could be more or less, depending on screen size */
}

.close {
  color: #aaa;
  float: right;
  font-size: 28px;
  font-weight: bold;
}

.close:hover,
.close:focus {
  color: black;
  text-decoration: none;
  cursor: pointer;
}

.redBorder {
  border: 2px solid #cc0000;
}

.errorDiv {
  color: #cc0000;
}

.reviews-tab-content .display-block-class {
  display: block;
}

@media print {
  /* TODO(mdc-migration): The following rule targets internal classes of card that may no longer apply for the MDC version. */
  mat-card.card-style {
    box-shadow: none;
  }
  .reviews-tab-content {
    max-height: none;
  }
  .tgpp-print-title {
    margin: 5px;
    display: block;
    float: left;
  }
  .tgpp-title {
    margin: 5px;
    color: rgb(189, 185, 185);
    display: block;
  }
  .title {
    display: flex;
    place-content: center;
    align-items: center;
  }
}`, "",{"version":3,"sources":["webpack://./src/app/feature/review-guidelines/review-guidelines.component.scss"],"names":[],"mappings":"AAAA;EACE,kBAAA;EACA,+BAAA;EACA,mBAAA;AACF;;AAEA;EACE,YAAA;EACA,eAAA;AACF;;AAEA,2HAAA;AACA;EACE,aAAA;AACF;;AAEA;EACE,eAAA;EACA,YAAA;AACF;;AAEA;EACE,aAAA;AACF;;AAEA;EACE,aAAA;AACF;;AAEA;EACE,iBAAA;AACF;;AAEA;EACE,cAAA,EAAA,sBAAA;EACA,eAAA,EAAA,kBAAA;EACA,UAAA,EAAA,eAAA;EACA,OAAA;EACA,MAAA;EACA,WAAA,EAAA,eAAA;EACA,YAAA,EAAA,gBAAA;EACA,cAAA,EAAA,4BAAA;EACA,8BAAA,EAAA,mBAAA;EACA,oCAAA,EAAA,qBAAA;EACA,gBAAA;AACF;;AAEA;EACE,YAAA;EACA,gBAAA;AACF;;AAEA;EACE,uBAAA;AACF;;AAEA;EAAsB,gBAAA;AAEtB;;AADA;EAA8C,UAAA;AAK9C;;AAJA,sBAAA;AAEA;EACE,6BAAA;EACA,gBAAA,EAAA,kCAAA;EACA,aAAA;EAEA,UAAA,EAAA,oDAAA;AAKF;;AAFA;EACE,WAAA;EACA,YAAA;EACA,eAAA;EACA,iBAAA;AAKF;;AAFA;;EAEE,YAAA;EACA,qBAAA;EACA,eAAA;AAKF;;AAFA;EACE,yBAAA;AAKF;;AAHA;EACE,cAAA;AAMF;;AAHA;EACE,cAAA;AAMF;;AAFA;EACE,2HAAA;EACA;IACE,gBAAA;EAKF;EAFA;IACE,gBAAA;EAIF;EADA;IACE,WAAA;IACA,cAAA;IACA,WAAA;EAGF;EAAA;IACE,WAAA;IACA,yBAAA;IACA,cAAA;EAEF;EAEA;IACE,aAAA;IACA,qBAAA;IACA,mBAAA;EAAF;AACF","sourcesContent":[".reviews-tab-content {\n  padding: 10px 25px;\n  max-height: calc(100vh - 200px);\n  text-align: justify;\n}\n\n.header-style {\n  margin: 10px;\n  font-size: 18px;\n}\n\n/* TODO(mdc-migration): The following rule targets internal classes of card that may no longer apply for the MDC version. */\nmat-card.card-style {\n  padding: 50px;\n}\n\n.tgpp-print-icon {\n  cursor: pointer;\n  float: right;\n}\n\n.tgpp-print-title {\n  display: none;\n}\n\n.tgpp-title {\n  display: none;\n}\n\n.card-style {\n  margin: 20px 30px;\n}\n\n.reviewguide-container .modal {\n  display: block; /* Hidden by default */\n  position: fixed; /* Stay in place */\n  z-index: 1; /* Sit on top */\n  left: 0;\n  top: 0;\n  width: 100%; /* Full width */\n  height: 100%; /* Full height */\n  overflow: auto; /* Enable scroll if needed */\n  background-color: rgb(0, 0, 0); /* Fallback color */\n  background-color: rgba(0, 0, 0, 0.4); /* Black w/ opacity */\n  margin-top: 40px;\n}\n\n.reviewguide-container input {\n  height: auto;\n  margin-top: 30px;\n}\n\n.reviewguide-container .update-disclaimer-button {\n  padding:  10px 10px 10px\n}\n\n.disclaimer-save-div {margin-top: 25px;}\n.reviewguide-container .mat-datepicker-input {width: 92%;}\n/* Modal Content/Box */\n\n.modal-content {\n  background-color: transparent;\n  margin: 10% auto; /* 15% from the top and centered */\n  padding: 20px;\n  // border: 1px solid #888;\n  width: 80%; /* Could be more or less, depending on screen size */\n}\n\n.close {\n  color: #aaa;\n  float: right;\n  font-size: 28px;\n  font-weight: bold;\n}\n\n.close:hover,\n.close:focus {\n  color: black;\n  text-decoration: none;\n  cursor: pointer;\n}\n\n.redBorder {\n  border: 2px solid #cc0000;\n}\n.errorDiv {\n  color: #cc0000;\n}\n\n.reviews-tab-content .display-block-class{\n  display: block;\n}\n\n\n@media print {\n  /* TODO(mdc-migration): The following rule targets internal classes of card that may no longer apply for the MDC version. */\n  mat-card.card-style {\n    box-shadow: none;\n  }\n\n  .reviews-tab-content {\n    max-height: none;\n  }\n\n  .tgpp-print-title {\n    margin: 5px;\n    display: block;\n    float: left;\n  }\n\n  .tgpp-title {\n    margin: 5px;\n    color: rgb(189, 185, 185);\n    display: block;\n    // float:right;\n  }\n\n  .title {\n    display: flex;\n    place-content: center;\n    align-items: center;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
